

export const chartList = [
    {
        id: 1,
        title: 'Solar Panel Voltage'
    },
    {
        id: 2,
        title: 'Solar Panel Current'
    },
    {
        id: 3,
        title: 'Solar Power'
    },
    // {
    //     id: 4,
    //     title: 'Temperature'
    // },
    {
        id: 5,
        title: 'Battery Voltage'
    },
    {
        id: 6,
        title: 'Battery Current'
    },
    {
        id: 7,
        title: 'Load Voltage'
    },
    // {
    //     id: 8,
    //     title: 'Load Current'
    // }
]

export const loginInfoJson = {
    id: 1,
    username: 'admin1',
    password: 'adminbis'
}

export const myThemeColor = [
    {
        id: 1,
        title: "theme-primary",
        colorCode: "#0052cc",
    },
    {
        id: 2,
        title: "theme-secondary",
        colorCode: "#b7c1d1",
    },
    {
        id: 3,
        title: "theme-info",
        colorCode: "#00baff",
    },
    {
        id: 4,
        title: "theme-success",
        colorCode: "#04a08b ",
    },
    {
        id: 5,
        title: "theme-danger",
        colorCode: "#ff562f ",
    },
    {
        id: 6,
        title: "theme-warning",
        colorCode: "#ff9920",
    }
];